import { useEffect, useState } from "react";
import {
  Eye,
  CheckCircle2,
  Lock,
  Paperclip,
  AlertTriangle,
  Send,
  FileText,
  ArrowRight,
  CheckCircle,
} from "lucide-react";

import apiClient from "../../../shared/API/apiClient";
import { useReportingYear } from "../../../context/ReportingYearContext";
import { useNavigate,useLocation } from "react-router-dom";

const PerformanceDisclosurePage = () => {
  const location=useLocation();

const passedEntityId=
  location.state?.legalEntityId || "";

const passedReportingYearId=
  location.state?.reportingYearId || "";

const passedReportingYear=location.state?.reportingYear || "";

const {reportingYear:contextReportingYear,reportingYearId:contextReportingYearId
}=useReportingYear();

const reportingYear=passedReportingYear || contextReportingYear;

const reportingYearId=passedReportingYearId || contextReportingYearId;

const [legalEntities, setLegalEntities] = useState([]);

  const [statusFilter, setStatusFilter] = useState("");

  const [principles, setPrinciples] = useState([]);
  const [statusCounts, setStatusCounts] = useState([]);

  const [summary, setSummary] = useState({
    completion_percentage: 0,
    evidence_files: 0,
    export_readiness: "",
  });

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [selectedEntity,setSelectedEntity]=useState(
  passedEntityId
);
  // =========================
  // LEGAL ENTITY API
  // =========================

  useEffect(() => {
    const fetchLegalEntities = async () => {
      if (!reportingYearId) return;

      try {
        const res = await apiClient.get(`/api/legal-entities-by-year`, {
          params: {
            reporting_year_id: reportingYearId,
          },
        });

        if (res.data.code === 200) {
          setLegalEntities(res.data.data || []);
        }
      } catch (error) {
        console.log(error);
      }
    };

    fetchLegalEntities();
  }, [reportingYearId]);

  // =========================
  // DEFAULT ENTITY
  // =========================
useEffect(()=>{

  if(
    legalEntities.length>0 &&
    !selectedEntity &&
    !passedEntityId
  ){

    setSelectedEntity(
      legalEntities[0].entity_id
    );
  }

},[
  legalEntities,
  selectedEntity,
  passedEntityId
]);

  // =========================
  // SECTION C API
  // =========================

  useEffect(() => {
    const fetchSectionCData = async () => {
      if (!reportingYearId || !selectedEntity) return;

      try {
        setLoading(true);

        const [sectionCRes, statusRes] = await Promise.all([
          apiClient.get(`/api/section-c`, {
            params: {
              reporting_year_id: reportingYearId,
              legal_entity_id: selectedEntity,
              status: statusFilter,
            },
          }),

          apiClient.get(`/api/section-c-statuscount`, {
            params: {
              reporting_year_id: reportingYearId,
              legal_entity_id: selectedEntity,
            },
          }),
        ]);

        if (sectionCRes.data.code === 200) {
          setPrinciples(sectionCRes.data.data || []);

          setSummary({
            disclosure_completion_progress_label:
              sectionCRes.data.disclosure_completion_progress_label ||
              "Disclosure Completion",

            completion_percentage:
              sectionCRes.data.disclosure_completion_precent || 0,

            disclosure_completion_progress_color:
              sectionCRes.data.disclosure_completion_progress_color,

            evidence_files: sectionCRes.data.total_evidence_counts || 0,

            export_readiness:
              sectionCRes.data.disclosure_completion_precent >= 100
                ? "Export Ready"
                : "Pending principle approvals",
          });
        }

        if (statusRes.data.code === 200) {
          setStatusCounts(statusRes.data.data || []);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };

    fetchSectionCData();
  }, [reportingYearId, selectedEntity, statusFilter]);

  // =========================
  // STATUS ICON
  // =========================

  const getStatusIcon = (status) => {
    switch (status?.toLowerCase()) {
      case "approved":
        return <CheckCircle2 size={24} />;

      case "locked":
        return <Lock size={24} />;

      case "submitted":
        return <Send size={24} />;

      case "draft":
        return <FileText size={24} />;

      default:
        return <AlertTriangle size={24} />;
    }
  };

  return (
    <div className="dash-page">
      {/* HEADER */}

      <div className="dash-page-title">
        Section C — Principle-wise Performance Disclosure
      </div>

      <div className="dash-page-subtitle">
        Review ESG performance disclosures generated from approved and locked
        Principle data and Activity Records.
      </div>

      {/* TOP ACTIONS */}

      <div className="section-c-top-actions">
        <button className="readonly-btn">
          <Eye size={16} />
          Read-only disclosure view
        </button>

       
      </div>

      {/* FILTER */}

      <div className="filter-card">
        <div className="filter-group">
          <label>Reporting Year *</label>

          <input
            className="filter-input"
            value={reportingYear || ""}
            disabled
          />
        </div>

        <div className="filter-group">
          <label>Legal Entity *</label>

          <select
            className="filter-input"
            value={selectedEntity}
            onChange={(e) => setSelectedEntity(e.target.value)}
          >
            <option value="">Select Legal Entity</option>

            {legalEntities.map((entity) => (
              <option key={entity.entity_id} value={entity.entity_id}>
                {entity.entity_name}
              </option>
            ))}
          </select>
        </div>
      </div>
 <div className="bms-info-bar">
        <Eye size={18} />

        <span>
          <strong>Section C is a read-only consolidation.</strong> Disclosure
          values are sourced from the Principle P1 to P9 modules.
        </span>
      </div>
      {/* SUMMARY CARDS */}

      <div className="sec-c-summary-grid">
        {/* DISCLOSURE */}

        <div className="sec-c-summary-card">
          <div className="summary-title">Disclosure Completion</div>

          <div className="summary-value">
            {Number(summary.completion_percentage).toFixed(0)}%
          </div>

          <div className="summary-progress">
            <div
              className="summary-progress-fill"
              style={{
                width: `${summary.completion_percentage}%`,
                background: `${summary.disclosure_completion_progress_color}`,
              }}
            />
          </div>

          <div className="summary-text">
            Approved KPI/performance disclosures available for final report
          </div>
        </div>

        {/* EVIDENCE */}

        <div className="sec-c-summary-card">
          <div className="summary-title">Evidence Files</div>

          <div className="summary-icon-row">
            <Paperclip size={18} />

            <div className="summary-value">{summary.evidence_files}</div>
          </div>

          <div className="summary-text">
            Total uploaded evidence linked to Principles & Activity Records
          </div>
        </div>

        {/* EXPORT */}

        <div
          className={`sec-c-summary-card ${
            summary.export_readiness === "Export Ready"
              ? "export-ready-card"
              : "warning-card"
          }`}
        >
          <div className="summary-title">Export Readiness</div>

          <div className="warning-row">
            {summary.export_readiness === "Export Ready" ? (
              <CheckCircle2 size={18} />
            ) : (
              <AlertTriangle size={18} />
            )}

            <span>{summary.export_readiness}</span>
          </div>

          <div className="summary-text">
            All required Principles must be approved or locked
          </div>
        </div>
      </div>

      {/* STATUS CARDS */}

      <div className="stats-row">
        {statusCounts.map((item) => {
          const currentStatus = item.status_code?.toLowerCase();

          return (
            <div
              key={item.id}
              className={`stat-card ${
                statusFilter === currentStatus ? "st-stat-card--active" : ""
              }`}
              style={{
                "--card-bg": item.color_code,
                "--card-fg": item.fore_color,
                "--card-border":
                  statusFilter === currentStatus
                    ? item.fore_color
                    : "transparent",
              }}
              onClick={() => {
                if (statusFilter === currentStatus) {
                  setStatusFilter("");
                } else {
                  setStatusFilter(currentStatus);
                }
              }}
            >
              <div
                className="stat-icon"
                style={{
                  "--icon-bg": item.color_code,
                  "--icon-fg": item.fore_color,
                  background: item.color_code,
                }}
              >
                {getStatusIcon(item.status_name)}
              </div>

              <div className="st-stat-body">
                <div className="stat-title">{item.status_name}</div>

                <div className="stat-value">{item.count}</div>
              </div>
            </div>
          );
        })}
      </div>

      {/* TABLE */}

      <div className="table-card">
        <div className="bms-table-header">
          <div className="process-head">
            Principle-wise Performance Disclosure
          </div>

          <div>
            {principles.length} of {principles.length}
          </div>
        </div>

        <table className="le-table">
          <thead>
            <tr>
              <th>PRINCIPLE</th>
              <th>DESCRIPTION</th>
              <th>STATUS</th>
              <th>COMPLETION %</th>
              <th>LAST UPDATED</th>
              <th>ACTION</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan={6} className="st-loading-row">
                  Loading...
                </td>
              </tr>
            ) : principles.length === 0 ? (
              <tr>
                <td colSpan={6} className="st-empty-row">
                  No data found.
                </td>
              </tr>
            ) : (
              principles.map((item, index) => (
                <tr key={index}>
                  {/* PRINCIPLE */}

                  <td>
                    <div className="sec-c-principle-cell">
                      <div className="principle-badge">
                        {item.principle_code}
                      </div>

                      <div>
                        <div className="st-principle-cell">
                          {item.principle_name}
                        </div>
                      </div>
                    </div>
                  </td>

                  {/* DESCRIPTION */}

                  <td>
                    <div className="principle-subtitle">
                      {item.principle_description}
                    </div>
                  </td>

                  {/* STATUS */}

                  <td>
                    <span
                            className="st-badge"
                            style={{
                              "--badge-bg": item.color_code,
                              "--badge-fg": item.fore_color,
                            }}
                          >
                            {item.icon_name && (
                             
                              <i className={`fa-solid ${item.icon_name ?? "fa-solid fa-circle"} status_icon_size`} />
                            )}
                            {item.status_display_name}
                          </span>
                  </td>

                  {/* COMPLETION */}

                  <td>
                    <div className="st-progress-row">
                      <div className="st-progress-bar">
                        <div
                          className="st-progress-fill"
                          style={{
                            "--bar-color": item.completion_progress_color,

                            "--bar-width": `${item.completion}%`,
                          }}
                        />
                      </div>

                      <span className="st-progress-text">
                        {item.completion}%
                      </span>
                    </div>
                  </td>

                  {/* DATE */}

                  <td className="st-date-cell">
                    {item.last_action_date || "-"}
                  </td>

                  {/* ACTION */}

                  <td>
                  
  {!item.action_lable||item.action_lable==="N/A"||!item.action_url||item.action_url==="N/A"
  ?"N/A"
  :(
    <div className="action">
    <span
      className="action-link"
      onClick={()=>navigate(item.action_url,{
        state:{
          legalEntityId:selectedEntity,
          reportingYearId,
          reportingYear,
          statusFilter,
          sourcePage:"section-c"
        }
      })}
      style={{cursor:"pointer"}}
    >
      {item.action_lable} →
    </span>
    </div>
  )
}

                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PerformanceDisclosurePage;
